export const SELECT_WITH_TAGS_ROLES = {
  TRIGGER: 'select-with-tags-trigger',
  LISTBOX: 'select-with-tags-listbox',
  OPTION: 'select-with-tags-option',
  OPTION_LABEL: 'select-with-tags-option-label',
  OPTION_TAG: 'select-with-tags-option-tag',
  SELECTED_VALUE: 'select-with-tags-selected-value',
  PLACEHOLDER: 'select-with-tags-placeholder',
};
